import { Container, Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import { getUserManager } from "../authentication-service.js";
export const Callback = () => /*#__PURE__*/React.createElement(Container, {
  maxWidth: "sm"
}, /*#__PURE__*/React.createElement(Typography, {
  component: "h1",
  gutterBottom: true
}, "Authentication complete"), /*#__PURE__*/React.createElement(Typography, {
  variant: "body1"
}, "You will be redirected to your application."));
export const CallbackContainer = _ref => {
  let {
    callbackComponentOverride,
    history
  } = _ref;
  useEffect(() => {
    ;

    (async () => {
      try {
        // In here we are most probably going to have userManager if not the error will be catched
        const user = await getUserManager().signinRedirectCallback();

        if (user.state.url) {
          history.push(user.state.url);
        } else {
          console.warn('no location in state');
        }
      } catch (error) {
        history.push(`/authentication/not-authenticated?message=${encodeURIComponent(error.message)}`);
      }
    })();
  }, [history]);
  return callbackComponentOverride ? /*#__PURE__*/React.createElement(React.Fragment, null, callbackComponentOverride) : /*#__PURE__*/React.createElement(Callback, null);
};
//# sourceMappingURL=callback.js.map